/**
 * Shared formatters for the B2B module. Same conventions as the rest of the
 * dashboard: ₹ with en-IN grouping and no paise, weights to one decimal.
 */

const inr = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 })

export const formatCurrency = (value: number): string => inr.format(Number(value || 0))

export const formatMoney = (value: number): string => `₹${formatCurrency(value)}`

/** 3 → "3", 3.5 → "3.5". Weights are DECIMAL(8,2) server-side. */
export const formatKg = (value: number): string => String(Number(Number(value || 0).toFixed(2)))

export const formatDate = (iso: string): string => {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })
}

/** "01–31 Aug 2026" / "01 Aug – 03 Sep 2026" for cycle chips. */
export const formatCycleRange = (startDate: string, endDate: string): string => {
  const start = new Date(startDate)
  const end = new Date(endDate)
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return `${startDate} – ${endDate}`
  }

  const sameMonth =
    start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()

  const day = (d: Date) => String(d.getDate()).padStart(2, '0')
  const monthYear = (d: Date) =>
    d.toLocaleDateString('en-IN', { month: 'short', year: 'numeric' })

  return sameMonth
    ? `${day(start)}–${day(end)} ${monthYear(end)}`
    : `${day(start)} ${monthYear(start)} – ${day(end)} ${monthYear(end)}`
}
